import React from 'react'
import { Link } from 'react-router-dom'
import "./topbar.css"

function TopBar() {
  let topDate = new Date().toUTCString()
  
  return (
    <div className='topbar'><div className="top"> <Link to = "/"> <img src={require("../photos/logostar.png")} alt="" /></Link> <div className='top__head'>Welcome&nbsp;,&nbsp;<h4>Guest</h4>:&nbsp;  <Link to="/join">Join Nairaland</Link>&nbsp; / <Link to="/login">&nbsp;LOGIN!</Link> &nbsp;/ <Link to="/log/trending">&nbsp;Trending</Link> &nbsp;/ <Link to="/log/recent">&nbsp;Recent</Link>&nbsp; / <Link to="/log/new">&nbsp;New&nbsp;</Link></div> </div><div className="mid"><span className="stats"><h4>Stats:</h4> 276,767,646 members, 6,585,238 topics.</span><span className="date"><h4>Date</h4>{topDate}/</span></div><div className="but"><input type="text" value= ' Disabled' disabled /><button>Search</button></div></div>
  )
}

export default TopBar